export default {
  en: {
    'pages-filing-summary-page-components.filing-header.buttons.notes': 'Notes & issues',
    'pages-filing-summary-page-components.filing-header.buttons.messages': 'Messages',
  },
};
